import React, { useEffect, useState } from "react";
import getLowResLink from "../utils/get-low-res-link";

const useLoadImage = ({ src }) => {
  const [imgSrc, setImgSrc] = useState(src ? getLowResLink(src) : "");

  useEffect(() => {
    let isMounted = true; // Track component mount state

    const loadImage = async (src) => {
      try {
        const imageLoader = new Image();
        imageLoader.src = src;

        await new Promise((resolve, reject) => {
          imageLoader.onload = resolve;
          imageLoader.onerror = reject;
        });

        if (isMounted) {
          setImgSrc(src);
        }
      } catch (error) {
        // Handle error if necessary
      }
    };

    if (src) {
      const srcLowRes = getLowResLink(src);
      setImgSrc(srcLowRes);

      loadImage(src);

      return () => {
        isMounted = false; // Mark component as unmounted when cleaning up
      };
    }
  }, [src]);

  return imgSrc;
};

export default useLoadImage;
